<template>
  <div class="products__list products__list--mobile">
    <div class="favorites-products">
      <div class="favorites-products__title-container">
        <img class="" src="/static/img/pictos/produitfavorisfondvert.svg" alt="">
        <h2 class="favorites-products__title">Mes produits favoris</h2>
        <!-- ProductFavoritesList -->
        <router-link
          :to="{name: 'ProductFavoritesList'}"
          class="favorites-products__btn"
        >
          <img src="/static/img/pictos/flecheblanche.svg" alt="">
        </router-link>
      </div>
      <div :class="'swiper-container swiper-favorites swiper-container--associated-products swiper-container--' + $store.getters['auth/role']">
        <div class="swiper-wrapper">
            <!-- Slides -->
            <div class="swiper-slide" v-for="item in items">
              <ProductFavorites :id="item.id" :class="'product--fullwidth product--no-border'"></ProductFavorites>
            </div>
        </div>
      </div>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    </div>
  </div>
</template>

<script>

import ProductFavorites from "@/components/Product/ProductFavorites";

export default {
  name: "ProductFavoritesSwiper",
  data() {
    return {

    };
  },
  mounted(){
    if (!this.items || !this.items.length) {
      this.isBusy = true;
    }
    if(this.$store.getters['auth/isRole']('ROLE_TECHNICIAN') == true){
      const swiper = new Swiper('.swiper-favorites', {
        slidesPerView: 1,
        slidesPerGroup: 1,
        preventClicks: false,
        preventClicksPropagation: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
    }
  },
  created() {
    // this.$store.dispatch('showLoader');
  },
  computed: {
    items: function() {
      if(this.myFavorites){
        let items = this.$store.getters["product/getAllCurrent"];
        return items.filter(i => this.myFavorites.includes(i.id))
      }
    },
    myFavorites: function() {
      let myFavorites = this.$store.getters["auth/myFavoritesProducts"];
      return myFavorites;
    },
  },
  methods: {

  },
  components: {
    ProductFavorites
  }
};
</script>


<style lang="scss" scoped>
  @import "~@/assets/scss/_colors.scss";

  .favorites-products{ padding: 0 20px; position: relative;
    &__title{ font-family: 'ClanFFBlack'; color: $vertjaune; font-size: 20px; position: relative; flex: 1; margin-bottom: 0;
    }
    &__title-container{ display: flex; align-items: center;
      img{ width: 35px; margin-right: 10px; }

    }
    &__btn{ width: 95px; background-color: $vertjaune; display: flex; align-items: center; justify-content: center; height: 50px;
      img{ width: 25px; margin-right: 0; }
    }
    .swiper-slide{ width: 100%;  }
    .swiper-button-prev{ left: 5px; width: 10px; background-size: contain; outline: none; }
    .swiper-button-next{ right: 5px; width: 10px; background-size: contain; outline: none; }
  }

</style>



// WEBPACK FOOTER //
// src/components/Product/ProductFavoritesSwiper.vue